import {
  inventoryItemIdFormat,
  sortDestinationIdFormat,
  sortingToteIdFormat,
  stationProcessingSessionIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { StationProcessingSessionToteBindingViewSchema } from "./station-processing-session";

export const recordItemSort = {
  name: "recordItemSort" as const,
  input: z.object({
    sessionId: stationProcessingSessionIdFormat.schema,
    inventoryItemId: inventoryItemIdFormat.schema,
    sortDestinationId: sortDestinationIdFormat.schema,
  }),
  output: z.object({
    bindings: z.array(StationProcessingSessionToteBindingViewSchema),
    sortedTo: z.object({
      sortingToteId: sortingToteIdFormat.schema,
      toteName: z.string(),
      sortDestinationId: sortDestinationIdFormat.schema,
      destinationName: z.string(),
    }),
  }),
};
